export const GLOBAL_SMS_CARD_IDS = {
  cardId: 'global-sms-metrics',
};

export const GLOBAL_SMS_CARD_TEXT = {
  cardTitle: 'Global SMS',
  description: 'Global SMS only includes messages sent and received via Iterable SMS.',
  smsSegmentsSentDescription: 'Total segments of SMS sent from Iterable SMS only from all projects',
  smsSegmentsSentName: 'SMS segments sent',
  smsSegmentsReceivedName: 'SMS segments received',
};

export const GLOBAL_SMS_COLUMNS = [
  { label: 'By Country' },
  { isNumeric: true, label: 'SMS Segments Sent' },
];
